import Button from '@doordash/component-button'
import { Stack } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as events from '../../../events'
// tslint:disable-next-line:max-line-length
import ScheduleOrientationConfirmation from '../../molecules/schedule-orientation-confirmation'
import ScheduleOrientationForm from '../../molecules/schedule-orientation-form'

import { get } from 'lodash'

import { Application } from 'src/utilities/application/application'
import t from './strings'
import { shouldSetupPaymentAccountAtOrientation } from '../../../utilities/orientation'
import * as Types from '../../../models/actionTypes'

type Props = OwnProps & StateProps & DispatchProps

interface OwnProps {
  application: Application
  uniqueLink: string
}

interface StateProps {
  scheduledOrientation?: any
  experiments?: object
}

interface DispatchProps {
  setSupplyAcquisitionMethod?: (string) => void
  createPaymentAccount?: (payload) => void
  trackGoBack?: (string) => void
}

export class ScheduleOrientation extends React.Component<Props> {
  public handleBackButton = () => {
    this.props.trackGoBack('scheduled_orientation')
    this.props.setSupplyAcquisitionMethod('')
  }

  public shouldRenderBackButton = () => {
    const { experiments, application } = this.props
    const dropshippingSkipSelection = get(
      experiments,
      'dropshipping_skip_selection',
      false
    )
    const isRescheduling = application.dasherOrientation != null
    const dropshipping = get(experiments, 'dropshipping', false)

    // If user skipped over selection
    // page should not render a back button
    return !dropshippingSkipSelection && !isRescheduling && dropshipping
  }

  public async componentDidMount() {
    const { application, createPaymentAccount } = this.props

    // Ideally this should be removed once we add
    // createPaymentAccount from the orientation page
    // JIRA: https://doordash.atlassian.net/browse/NZL-333
    if (shouldSetupPaymentAccountAtOrientation(application.country)) {
      const dob = application.dateOfBirth.split('-')
      const paymentPayload: Types.PaymentPayload = {
        target_id: application.dasherId,
        first_name: application.firstName,
        last_name: application.lastName,
        date_of_birth: {
          year: dob[0],
          month: dob[1],
          day: dob[2],
        },
        target_type: 'dasher',
        personal_identification_number: '',
      }

      await createPaymentAccount(paymentPayload)
    }
  }

  public render() {
    const {
      application,
      uniqueLink,
      scheduledOrientation,
      experiments,
    } = this.props

    if (scheduledOrientation) {
      return (
        <ScheduleOrientationConfirmation
          experiments={experiments}
          uniqueLink={uniqueLink}
          orientation={scheduledOrientation}
          application={application}
          timezone={application.timezone}
        />
      )
    }

    return (
      <React.Fragment>
        <Stack size={Stack.Sizes.XLarge}>
          {this.handleBackButton && this.shouldRenderBackButton() && (
            <Button
              onClick={this.handleBackButton}
              type={Button.Types.TertiaryPill}
              size={Button.Sizes.Small}
              isInline
            >
              {`< ${t.back()}`}
            </Button>
          )}
        </Stack>
        <ScheduleOrientationForm
          application={application}
          uniqueLink={uniqueLink}
          timezone={application.timezone}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    scheduledOrientation: state.scheduledOrientation,
    experiments: state.experiments,
  }
}

const mapDispatchToProps = {
  setSupplyAcquisitionMethod: actions.setSupplyAcquisitionMethod,
  createPaymentAccount: actions.createPaymentAccount,
  trackGoBack: events.trackGoBack,
}

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleOrientation)
